var React = require('react');

function UserLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 25a9.5 9.5 0 119.5-9.5A9.51 9.51 0 0124 25zm0-17a7.5 7.5 0 107.5 7.5A7.51 7.51 0 0024 8zm14 34H10a1 1 0 01-1-1 15 15 0 0130 0 1 1 0 01-1 1zm-27-2h25.93A13 13 0 0011 40z"}));
}

UserLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = UserLight;

UserLight.default = UserLight;
